import api from "../../service/api";
import { createApiStore } from "../genericStore";

// --- TİP TANIMLAMALARI ---
export interface AdminReportFilters {
  userIds?: number[] | null;
  userId?: number | null;
  dateRange?: (Date | null)[] | null;
  operationType?: 'ALL' | 'PICK' | 'PACK';
  isLiveActive?: boolean;
  warehouseId?: number | null;
}
const toLocalISOString = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
// 1. Base Store Oluşturma (Bağlantı noktası)
const useReportBaseStore = createApiStore<any>("warehouse-report");

// 2. Raporlara Özel Fonksiyonlarla Genişletilmiş Store
export const useWarehouseReportStore = () => {
  const store = useReportBaseStore();

  // Ortak tarih formatlayıcı (UI'dan gelen Date[] array'ini backend'in istediği formata çevirir)
const formatDates = (dateRange?: (Date | null)[] | null) => {
  const start = dateRange?.[0] ?? new Date();
  const end = dateRange?.[1] ?? new Date();

  start.setHours(0,0,0,0);
  end.setHours(23,59,59,999);

  return {
    startDate: toLocalISOString(start),
    endDate: toLocalISOString(end),
  };
};

  return {
    ...store,

    /**
     * DİNAMİK RAPOR (Yüzdelik ilerlemeye sahip, filtreli ana tablo)
     */
    getDynamicAdminReport: async (filters: AdminReportFilters) => {
      const { startDate, endDate } = formatDates(filters.dateRange);

      const payload = {
        ...filters,
        dateRange: { startDate, endDate }
      };

      const res = await api.post("/warehouse-report/DynamicAdminReport", payload, {
        headers: { "x-silent": "true" }
      });
      return res.data;  
    },
    
getDashboardData: async (filters: AdminReportFilters, options?: { signal?: AbortSignal }) => {
      const { startDate, endDate } = formatDates(filters.dateRange);
      
      const payload = {
        warehouseId: filters.warehouseId,
        startDate,
        endDate,
        isLiveActive: filters.isLiveActive,
       userIds: filters.userIds, // <-- BURANIN UNUTULMADIĞINDAN EMİN OL
    userId: filters.userId, // Geriye uyumluluk için tekil userId de gönderiyoruz
        operationType: filters.operationType
      };

      const res = await api.post("/warehouse-report/DashboardData", payload, options ? { signal: options.signal } : undefined);
      return res.data; // { summary, logs, performance, totalLogs }
    },
    /**
     * KPI ÖZETLERİ (En üstteki istatistik kartları)
     */
    getDashboardSummary: async (filters: AdminReportFilters) => {
      const { startDate, endDate } = formatDates(filters.dateRange);
      
      const payload = {
        warehouseId: filters.warehouseId,
        startDate,
        endDate
      };

      const res = await api.post("/warehouse-report/DashboardSummary", payload);
      return res.data;
    },

    /**
     * CANLI İŞLEM LOGLARI (Saniye saniye kim ne yaptı tablosu)
     */
    getLiveActionLogs: async (filters: AdminReportFilters, pageIndex: number = 0, pageSize: number = 50) => {
      const { startDate, endDate } = formatDates(filters.dateRange);
      
      const payload = {
        warehouseId: filters.warehouseId,
        startDate,
        endDate
      };

      const res = await api.post(`/warehouse-report/LiveActionLogs?pageIndex=${pageIndex}&pageSize=${pageSize}`, payload, {
        headers: { "x-silent": "true" }
      });
      return res.data; // { items: [...], total, pageIndex, pageSize } döner
    },

    /**
     * PERSONEL PERFORMANS RAPORU (Toplanan/Paketlenen iş sayıları)
     */ 
    getStaffPerformance: async (filters: AdminReportFilters, options?: { signal?: AbortSignal }) => {
      const { startDate, endDate } = formatDates(filters.dateRange);
      
      const payload = {
        warehouseId: filters.warehouseId,
        startDate,
        endDate,
        userIds: filters.userIds, 
        userId: filters.userId, 
        operationType: filters.operationType
      };

      const res = await api.post(
        "/warehouse-report/StaffPerformance", 
        payload, 
        options ? { signal: options.signal } : undefined
      );
      return res.data;
    },

    /**
     * EKSİK (SHORTAGE) ANALİZİ
     */
    getShortageAnalytics: async (filters: AdminReportFilters) => {
      const { startDate, endDate } = formatDates(filters.dateRange);
      
      const payload = {
        warehouseId: filters.warehouseId,
        startDate,
        endDate
      };

      const res = await api.post("/warehouse-report/ShortageAnalytics", payload);
      return res.data;
    }
  };
};